import { Copy } from "@tamagui/lucide-icons-2";
import { View } from "tamagui";
import { Input } from "./components/inputsParts.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function InputWithRightAddOnDemo({
  size
}) {
  return /* @__PURE__ */jsx(View, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: 100,
    children: /* @__PURE__ */jsx(Input, {
      size,
      children: /* @__PURE__ */jsxs(Input.Box, {
        children: [/* @__PURE__ */jsx(Input.Section, {
          children: /* @__PURE__ */jsx(Input.Area, {
            focusStyle: {
              outlineOffset: 1
            },
            placeholder: "Copy this text"
          })
        }), /* @__PURE__ */jsx(Input.Section, {
          children: /* @__PURE__ */jsx(Input.Button, {
            children: /* @__PURE__ */jsx(Input.Icon, {
              children: /* @__PURE__ */jsx(Copy, {})
            })
          })
        })]
      })
    })
  });
}
InputWithRightAddOnDemo.fileName = "InputWithRightAddOn";
const InputWithRightAddOnControlled = props => {
  const {
    icon,
    placeholderText,
    onChange,
    value
  } = props;
  const inputProps = {};
  if (props.onBlur) {
    inputProps["onBlur"] = props.onBlur;
  }
  const buttonProps = {};
  if (props.onButtonPress) {
    buttonProps["onPress"] = props.onButtonPress;
  }
  const idProps = {
    InputLabel: {},
    InputArea: {}
  };
  if (props.id) {
    idProps.InputLabel["htmlFor"] = props.id;
    idProps.InputArea["id"] = props.id;
  }
  return /* @__PURE__ */jsx(View, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: 100,
    ...(props.viewProps || {}),
    children: /* @__PURE__ */jsx(Input, {
      width: "100%",
      ...inputProps,
      children: /* @__PURE__ */jsxs(Input.Box, {
        children: [props.label ? /* @__PURE__ */jsx(Input.Label, {
          ...idProps.InputLabel,
          children: props.label
        }) : null, /* @__PURE__ */jsx(Input.Section, {
          children: /* @__PURE__ */jsx(Input.Area, {
            focusStyle: {
              outlineOffset: 1
            },
            placeholder: placeholderText,
            onChange,
            value,
            ...idProps.InputArea
          })
        }), /* @__PURE__ */jsx(Input.Section, {
          children: /* @__PURE__ */jsx(Input.Button, {
            ...buttonProps,
            children: /* @__PURE__ */jsx(Input.Icon, {
              children: icon
            })
          })
        })]
      })
    })
  });
};
export { InputWithRightAddOnControlled, InputWithRightAddOnDemo };
//# sourceMappingURL=InputWithRightAddOn.mjs.map
